/**
 * Тип награды реферальной программы (когда именно выдаётся награда).
 * - activated — награда рефереру/рефералу за активированного реферала;
 * - welcome   — приветственная награда самому рефералу.
 * Список известных значений; при появлении новых — расширить enum.
 */
export enum ReferralRewardTypeEnum {
  ACTIVATED = 'activated',
  WELCOME = 'welcome',
}

/**
 * Тип выдаваемого предмета награды.
 * - free-case      — бесплатный кейс;
 * - free-case-item — предмет из бесплатного кейса;
 * - wallet         — фиксированная сумма на кошелёк;
 * - wallet-percent — процент от суммы депозита на кошелёк.
 */
export enum ReferralRewardItemTypeEnum {
  FREE_CASE = 'free-case',
  FREE_CASE_ITEM = 'free-case-item',
  WALLET = 'wallet',
  WALLET_PERCENT = 'wallet-percent',
}

/**
 * Известные типы кампаний реферальной программы.
 * campaignType — СВОБОДНАЯ строка (могут появляться новые типы), поэтому список
 * используется лишь как datalist/подсказка для ввода, а не как фиксированный select.
 */
export const KNOWN_REFERRAL_CAMPAIGN_TYPES: string[] = [
  'gofast',
  'gofast-custom-percent',
  'gofast-custom-money',
  'cases',
  'cases-custom-percent',
  'cases-custom-money',
];
